import React from "react";
import { useGetOperationsQuery } from "../../features/operations/operationApi";
import useRelationOperations from "../../features/operations/useRelationOperations";
import RelationTypeSelect from "../../features/relationTypes/RelationTypeSelect";
import PaginatedSelect from "../../components/ui/PaginatedSelect";
import ActionButton from "../../components/ui/ActionButton";
import { buildNameCodeIdLabel } from "./masterMetadata";

export default function RoutingOperationFields({ plantId, row, index, selectedOperationIds, onOperationChange, onRelationChange, disabled }) {
  const lookup = useGetOperationsQuery({ plant_id: plantId, operation_id: row.operation_id, page: 1, limit: 1000 }, {
    skip: !plantId || !row.operation_id || Boolean(row.relation_type),
  });
  const existing = lookup.currentData?.data?.find((operation) => operation.operation_id === row.operation_id && operation.plant_id === plantId);
  const relationType = row.relation_type || existing?.relation_type?.toUpperCase() || "";
  const { options, isLoading, error, retry } = useRelationOperations(plantId, relationType);
  const available = options.filter((option) => option.value === row.operation_id || !selectedOperationIds.includes(option.value));
  if (row.operation_id && !available.some((option) => option.value === row.operation_id)) {
    available.push({ value: row.operation_id, label: existing ? buildNameCodeIdLabel({ name: existing.operation_name, code: existing.operation_code, id: existing.operation_id }) : row.operation_id });
  }

  return (
    <div className="min-w-0 space-y-2">
      <RelationTypeSelect
        plantId={plantId}
        value={relationType}
        label={`Relation Type ${index + 1}`}
        onChange={(nextType) => { if (nextType !== relationType) onRelationChange(nextType); }}
        disabled={disabled}
      />
      <label className="block">
        <span className="mb-1.5 block text-sm font-medium text-slate-700">Operation {index + 1}</span>
        <PaginatedSelect
          value={row.operation_id}
          options={available}
          onChange={onOperationChange}
          disabled={disabled || !relationType || isLoading || Boolean(error)}
          placeholder={!relationType ? "Select relation type first" : isLoading ? "Loading operations..." : "Select operation"}
        />
      </label>
      {error && <div role="alert" className="text-sm text-red-600">
        {error}
        <ActionButton label={`Retry operations ${index + 1}`} onClick={retry} disabled={disabled} />
      </div>}
      {relationType && !isLoading && !error && !options.length && <p className="text-sm text-slate-500">No operations found for this relation type.</p>}
    </div>
  );
}
